import { Injectable } from '@angular/core';
import { ApplicationInitializationService } from './application-initialization.service';

@Injectable({ providedIn: 'root' })
export class MagentoStorefrontEventsService {
  private storefrontCtx: any;
  private pageCtx: any;
  private productCtx: any[] = [];
  private shoppingCartContext: any = {};
  private orderContext: any = {};

  constructor(private AIS: ApplicationInitializationService) {
    this.storefrontCtx = AIS.environmentConfig.MAGENTO_STOREFRONT_CONFIGURATIONS || {
      environmentId: '0395851a-203a-4580-b349-937b7d767b57',
      instanceId: 'staging',
      environment: 'staging',
      storeUrl: 'https://etisalat.ae',
      storeViewCode: 'en',
      storeViewCurrencyCode: 'AED',
      baseCurrencyCode: 'AED',
      storeId: 111,
      websiteId: 222,
      storeName: 'magento',
      storeViewName: 'default',
      websiteName: 'etisalat.ae'
    };

    this.pageCtx = {
      pageType: 'Category',
      pageName: 'CategoryPage',
      pageURL: window.location.href,
      minXOffset: 0, maxXOffset: 0, minYOffset: 0, maxYOffset: 0,
      ping_interval: 0, pings: 0
    };
  }

  private get magentoStorefrontEvents(): any {
    return (window as any).magentoStorefrontEvents;
}
private setPageContext(pageType: string, pageName: string, pageURL: string) {
    this.pageCtx.pageType = pageType || '';
    this.pageCtx.pageName = pageName || '';
    this.pageCtx.pageURL = pageURL || window.location.href || '';
    this.pageCtx.minXOffset = 0;
    this.pageCtx.maxXOffset = 0;
    this.pageCtx.minYOffset = 0;
    this.pageCtx.maxYOffset = 0;
    this.pageCtx.ping_interval = 0;
    this.pageCtx.pings = 0;
  }
  private setProductContextArray(eventDetails: any) {
    const items = eventDetails?.ecommerce?.items || [];
    const currency = eventDetails.ecommerce.currency || 'AED';
    this.productCtx = items.map((item: any) => {
      const price = parseFloat(item.price) || 0;
      return {
        productId: String(item.item_id),
        name: item.item_name || '',
        sku: item.item_id || '',
        topLevelSku: item.item_list_id || '',
        categories: item.item_category ? [item.item_category] : [],
        productType: 'configurable',
        mainImageUrl: '',
        canonicalUrl: '',
        pricing: {
          regularPrice: price,
          minimalPrice: price,
          maximalPrice: price,
          currencyCode: currency,
        }
      };
    });
  }

  private setShoppingCartContext(eventDetails: any) {
    const items = eventDetails?.ecommerce?.items || [];
    const currency = eventDetails.ecommerce.currency || 'AED';
    const totalValue = parseFloat(eventDetails.ecommerce.value) || 0;

    this.shoppingCartContext.id = eventDetails.ecommerce.transaction_id || '';
    this.shoppingCartContext.items = items.map((item: any) => {
      const price = parseFloat(item.price) || 0;
      const quantity = parseInt(item.quantity || '1', 10);
      const productMatch = this.productCtx.find(p => p.productId === String(item.item_id)) || {};

      return {
        canApplyMsrp: false,
        formattedPrice: `${currency} ${price.toFixed(2)}`,
        id: String(item.item_id),
        prices: {
          price: {
            value: price,
            currency,
            regularPrice: price,
          }
        },
        product: productMatch,
        quantity
      };
    });

    const totalQuantity = this.shoppingCartContext.items.reduce((sum: number, i: any) => sum + i.quantity, 0);
    this.shoppingCartContext.prices = {
      subtotalExcludingTax: { value: totalValue, currency },
      subtotalIncludingTax: { value: totalValue, currency }
    };
    this.shoppingCartContext.totalQuantity = totalQuantity;
    this.shoppingCartContext.possibleOnepageCheckout = true;
    this.shoppingCartContext.giftMessageSelected = false;
    this.shoppingCartContext.giftWrappingSelected = false;
  }

  private setMockOrder(eventDetails: any, email: string) {
    const val = parseFloat(eventDetails.ecommerce.value) || 0;
    const txn = eventDetails.ecommerce.transaction_id || '';
    const coupon = eventDetails.ecommerce.coupon || '';
    const tax = parseFloat(eventDetails.ecommerce.tax) || 0;
    const shipping = parseFloat(eventDetails.ecommerce.shipping) || 0;
    const paymentMethod = localStorage.getItem('paymentMethod') || 'unknown';

    this.orderContext = {
      appliedCouponCode: coupon,
      email: email || '',
      grandTotal: val,
      orderId: txn,
      orderType: 'checkout',
      otherTax: 0.0,
      paymentMethodCode: paymentMethod,
      paymentMethodName: paymentMethod,
      payments: [{
        paymentMethodCode: paymentMethod,
        paymentMethodName: paymentMethod,
        total: val
      }],
      salesTax: tax,
      subtotalExcludingTax: val,
      subtotalIncludingTax: val,
      shipping: {
        shippingAmount: shipping,
        shippingMethod: 'standard'
      }
    };
  }

  public Purchase(eventDetails: any, email: string) {
    const mse = this.magentoStorefrontEvents;
    if (mse && mse.publish && mse.context) {
    this.setPageContext('purchase', 'success', document.URL);
    this.setProductContextArray(eventDetails);
    this.setShoppingCartContext(eventDetails);
    this.setMockOrder(eventDetails, email);

    mse.context.setPage(this.pageCtx);
    mse.context.setStorefrontInstance(this.storefrontCtx);
    mse.context.setShoppingCart(this.shoppingCartContext);
    mse.context.setOrder(this.orderContext);
    mse.publish.placeOrder();
    }
  }
}
 